// Site-wide constants for Dr. Jairo Franco
export const SITE = {
  doctor: "Dr. Jairo Franco",
  specialty: "Ginecología y Obstetricia",
  credentials: [
    "Especialista en Ginecología y Obstetricia",
    "Maestro en Administración Hospitalaria",
  ],
  tagline: "Ginecología y Obstetricia con enfoque en calidad, seguridad y experiencia de la paciente.",
  cedulaEspecialidad: "11533442",
  whatsappRaw: "525570466065",
  whatsappDisplay: "+52 55 7046 6065",
  bookingUrl: "https://agenda-obstetrica.emergent.host/?utm_source=share",
  facebook: "https://www.facebook.com/share/1CH3H8ucZc/?mibextid=wwXIfr",
  googleReviews: "https://share.google/GRaEQbO60OWu9edL2",
  email: "contacto@drjairofranco.mx",
  addresses: [
    {
      place: "Centro Médico Dr. Neftalí",
      street: "Av. Las Torres #7",
      neighborhood: "Barrio Texcacoa",
      city: "Tepotzotlán",
      state: "Estado de México",
      mapsQuery: "Centro Médico Dr. Neftalí, Av. Las Torres 7, Barrio Texcacoa, Tepotzotlán",
    },
    {
      place: "Clínica de Especialidades Médicas Santiago Apóstol",
      street: "",
      neighborhood: "Santiago Cuautlalpan",
      city: "Tepotzotlán",
      state: "Estado de México",
      mapsQuery: "Clínica de Especialidades Médicas Santiago Apóstol, Santiago Cuautlalpan, Tepotzotlán",
    },
  ],
  logo: "https://customer-assets.emergentagent.com/job_clinica-franco-gyn/artifacts/rithjzb2_logo%20jairo.png",
  images: {
    heroDoctor: "https://customer-assets.emergentagent.com/job_clinica-franco-gyn/artifacts/qlf40og6_ChatGPT%20Image%202%20jun%202026%2C%2020_12_25.png",
    prenatal: "https://images.pexels.com/photos/13958031/pexels-photo-13958031.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    abstractBg: "https://images.unsplash.com/photo-1585854467604-cf2080ccef31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwYWJzdHJhY3QlMjB3aGl0ZSUyMGJsdWV8ZW58MHx8fHwxNzgwNjI2NTEwfDA&ixlib=rb-4.1.0&q=85",
    abstractTexture: "https://images.unsplash.com/photo-1658604663578-04634f4cb897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwYWJzdHJhY3QlMjB3aGl0ZSUyMGJsdWV8ZW58MHx8fHwxNzgwNjI2NTEwfDA&ixlib=rb-4.1.0&q=85",
    doctorPortrait: "https://customer-assets.emergentagent.com/job_clinica-franco-gyn/artifacts/7is3l3mb_ChatGPT%20Image%202%20jun%202026%2C%2020_20_16.png",
    motherChild: "https://images.unsplash.com/photo-1519791883288-dc8bd696e667?crop=entropy&cs=tinysrgb&fm=jpg&q=85&w=1200",
    pinkFlower: "https://images.unsplash.com/photo-1518495973542-4542c06a5843?crop=entropy&cs=tinysrgb&fm=jpg&q=85&w=1200",
  }
};

export const waLink = (msg = "Hola Dr. Jairo Franco, me gustaría agendar una consulta.") =>
  `https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(msg)}`;
